// main.tsx
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router";
import { initializeApp } from "firebase/app";
import { appConfig } from "./configs";
import { AppProviders } from "./providers/AppProviders";
import { AppRoutes } from "./configs/routes";
import ScrollToTop from "./ScrollToTop";
import App from "./App";
import { initializeApp as initializeAppServices } from "./services";
import { initMetaPixel } from "@nusrif/services";
import "./styles/globals.css";


// Initialize Firebase
initializeApp(appConfig.firebase);

// Initialize Meta Pixel
initMetaPixel();

async function bootstrap() {
  // Initialize app services (push messaging, status bar, etc.)
  await initializeAppServices();

  // Mount React app
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <BrowserRouter>
        <AppProviders>
          <ScrollToTop />
          <App />
          <AppRoutes />
        </AppProviders>
      </BrowserRouter>
    </React.StrictMode>
  );
}

bootstrap();
